import React, { useState } from 'react'
import {  IntegrationInitialData } from '../types/interface'


const initialData: IntegrationInitialData = {
    files: [],
    uploadStatus: '',
    progressRate: 0,
    updateProgressRate: (rate) => {},
    updateUploadStatus: (status) => {},
    updateFiles: (files) => {},
    setDefault: () => {}
}

export const IntegrationContext = React.createContext(initialData)

const IntegrationContextProvider = (props: any) => {

    const [files, setFiles] = useState(initialData.files)
    const [uploadStatus, setUploadStatus] = useState(initialData.uploadStatus) // progress, success, failed
    const [progressRate, setProgressRate] = useState(initialData.progressRate) // 0 -100 percent

    const updateProgressRate = (rate: number = initialData.progressRate) => {
        setProgressRate(rate)
    }

    const updateUploadStatus = (status: string = initialData.uploadStatus) => {
        setUploadStatus(status)
    }

    const updateFiles = (files: File[] = initialData.files) => {
        setFiles(files)
    }

    const setDefaultHandler = () => {
        updateProgressRate()
        updateUploadStatus()
        updateFiles()
    }

    const contextValue = {
        files: files,
        uploadStatus: uploadStatus,
        progressRate: progressRate,
        updateProgressRate: updateProgressRate,
        updateUploadStatus: updateUploadStatus,
        updateFiles: updateFiles,
        setDefault: setDefaultHandler,
    }

    return (
        <IntegrationContext.Provider value={contextValue}>
            {props.children}
        </IntegrationContext.Provider>
    )
}

export default IntegrationContextProvider
